// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { ProjectStatusIdEnum } from 'config/enums'
import { castToFloat } from 'helpers/reduxFormFunctions'
import React from 'react'
import { array, bool, func, string } from 'prop-types'
import { connect } from 'react-redux'
import CopyProjects from './CopyProjects'
import DeleteProjects from './DeleteProjects'
import PathReportExport from 'components/PathReportExport'

const ModalTemplates = props => {
  const {
    allRowsHighlighted,
    closeModal,
    highlightedRows,
    modalTemplate,
    datasheetVersion,
    sourceForm,
    supportUnderline,
    triggerSearch,
  } = props

  if (modalTemplate === 'copy-projects') {
    return (
      <CopyProjects
        closeModal={closeModal}
        highlightedRows={highlightedRows} />
    )
  }

  if (modalTemplate === 'delete-projects') {
    return (
      <DeleteProjects
        closeModal={closeModal}
        highlightedRows={highlightedRows}
        modalTemplate={modalTemplate}
        sourceForm={sourceForm}
        triggerSearch={triggerSearch} />
    )
  }

  if (modalTemplate === 'path-reports') {
    return (
      <PathReportExport
        allRowsHighlighted={allRowsHighlighted}
        asc={'true'}
        closeModal={closeModal}
        dataSource={'projects'}
        highlightedRows={highlightedRows}
        idRoot={'project-management-path-reports'}
        datasheetVersion={datasheetVersion}
        sourceForm={sourceForm}
        supportUnderline={supportUnderline} />
    )
  }

  return (
    <div>
      {`Warning: unmapped modal template of ${modalTemplate}`}
    </div>
  )
}

ModalTemplates.propTypes = {
  allRowsHighlighted: bool.isRequired,
  closeModal: func.isRequired,
  highlightedRows: array.isRequired,
  modalTemplate: string.isRequired,
  datasheetVersion: string.isRequired,
  sourceForm: string.isRequired,
  supportUnderline: bool.isRequired,
  triggerSearch: func.isRequired,
}

const mapStateToProps = ({ form }, { sourceForm }) => {
  const { projectStatusId } = form[sourceForm].values
  const projectIsFinalized = castToFloat(projectStatusId) === ProjectStatusIdEnum.FINALIZED

  // based on the project management form (has user name, project name and project status fields)
  // determine if the datasheetVersion of a path report should be 'DATABASE' (if project's 'Finalized')
  // or 'prePCN' (if 'In Progress' or 'Pending')
  // NOTE -  there is a datasheet version called 'PCN' which should be used when projectStatus === 'finalized'
  // however there was bug with the PCN of this document. Fixing that document was deemed not worth it
  // so the UI instead explicitly uses the DATABASE version for projectStatus === 'finalized'.

  const datasheetVersion = (
    projectIsFinalized
      ? 'DATABASE'
      : 'prePCN'
  )

  const supportUnderline = !projectIsFinalized

  return {
    datasheetVersion,
    supportUnderline,
  }
}

export default connect(
  mapStateToProps,
)(ModalTemplates)
